/**
 * @file
 * A picked tag pill.
 */

((Drupal) => {
  const { berTags } = Drupal;
  const { components } = berTags;
  const { el, button, colorDot, textSpan } = berTags.dom;

  // A picked tag. Fill style paints it, meta.text keeps the text readable.
  // opts.editLink adds a pencil opening the entity's edit form in a new
  // tab when the meta carries an editUrl (only sent with edit access).
  components.tag = (item, meta, color, fill, opts = {}) => {
    const tag = el('span', 'ber-tag');
    tag.setAttribute('role', 'listitem');
    tag.dataset.id = item.id;
    // Focusable so the arrow keys can reorder it.
    tag.tabIndex = 0;

    if (color) {
      tag.style.borderColor = color;
      if (fill) {
        tag.classList.add('ber-tag--fill');
        tag.style.background = color;
        if (meta.text) {
          tag.style.color = meta.text;
        }
        tag.appendChild(colorDot('#fff'));
      } else {
        tag.appendChild(colorDot(color));
      }
    }
    tag.appendChild(textSpan('ber-tag__label', item.label));
    if (meta.type) {
      tag.appendChild(textSpan('ber-tag__type', meta.type));
    }
    if (opts.editLink && meta.editUrl) {
      const edit = el('a', 'ber-tag__edit');
      edit.href = meta.editUrl;
      edit.target = '_blank';
      edit.rel = 'noopener';
      edit.setAttribute(
        'aria-label',
        Drupal.t('Edit @label (opens in a new tab)', { '@label': item.label }),
      );
      tag.appendChild(edit);
    }
    tag.appendChild(
      button('ber-tag__x', Drupal.t('Remove @label', { '@label': item.label })),
    );
    return tag;
  };
})(Drupal);
